import {colors} from './colors'
import {shadows} from './shadows'
import {radii} from './radii'

export const semanticTokens = {
    colors,
    shadows,
    radii
}
